var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E6F5EE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15889_6619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8146 7.47777H8.40798C7.89435 7.47777 7.47754 7.06095 7.47754 6.54733V5.12966C7.47754 4.61603 7.89435 4.19922 8.40798 4.19922H13.8146C14.3282 4.19922 14.745 4.61603 14.745 5.12966V6.54733C14.745 7.06158 14.3282 7.47777 13.8146 7.47777Z",
    fill: "#038A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0656 14.2502C19.4872 13.6718 18.5442 13.6718 17.9658 14.2502L17.2793 14.9405L19.3803 17.0409L20.0656 16.3556C20.6503 15.7716 20.6503 14.8349 20.0656 14.2502Z",
    fill: "#038A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6159 15.6094L12.9508 19.2683C12.8753 19.35 12.825 19.4506 12.8062 19.5575L12.5295 21.1857C12.4667 21.5441 12.781 21.8521 13.1394 21.7956L14.7676 21.5189C14.8745 21.5001 14.9751 21.4498 15.0505 21.3743L18.7157 17.7092L16.6159 15.6094Z",
    fill: "#038A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.47 5.83984H15.6873V6.5471C15.6873 7.58002 14.8468 8.42056 13.8139 8.42056H8.40725C7.3737 8.42056 6.53379 7.58002 6.53379 6.5471V5.83984H5.73852C4.50002 5.83984 3.49414 6.84573 3.49414 8.08422V19.5576C3.49414 20.7961 4.50002 21.8019 5.73852 21.8019H11.6839C11.5884 21.5561 11.5525 21.2896 11.599 21.0236L11.875 19.3998C11.9241 19.1118 12.0561 18.8459 12.2547 18.629L16.2563 14.6331L17.2967 13.587C17.6834 13.1998 18.1794 12.9703 18.7131 12.9043V8.09051C18.7144 6.83944 17.7148 5.83984 16.47 5.83984ZM10.1317 15.165H7.40388C7.09143 15.165 6.83807 14.9116 6.83807 14.5992C6.83807 14.2867 7.09143 14.0334 7.40388 14.0334H10.1317C10.4442 14.0334 10.6975 14.2867 10.6975 14.5992C10.6975 14.9116 10.4442 15.165 10.1317 15.165ZM13.4712 11.9537H7.40451C7.09206 11.9537 6.8387 11.7004 6.8387 11.3879C6.8387 11.0755 7.09206 10.8221 7.40451 10.8221H13.4712C13.7837 10.8221 14.037 11.0755 14.037 11.3879C14.037 11.7004 13.7837 11.9537 13.4712 11.9537Z",
    fill: "#038A4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15889_6619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormIcon);
export default __webpack_public_path__ + "static/media/formIcon.7651804a0c087427cee31fbc8cc9079b.svg";
export { ForwardRef as ReactComponent };